export const ITINERARY_STATE = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PAID: "PAID",
    CANCELLED: "CANCELLED",
    EXPIRED: "EXPIRED",
};
export const ITINERARY_STATE_VALUES = [
    ITINERARY_STATE.PENDING,
    ITINERARY_STATE.APPROVED,
    ITINERARY_STATE.REJECTED,
    ITINERARY_STATE.PAID,
    ITINERARY_STATE.CANCELLED,
    ITINERARY_STATE.EXPIRED,
];
export const ITINERARY_STATE_CONFIG = {
    [ITINERARY_STATE.PENDING]: {
        value: ITINERARY_STATE.PENDING,
        labelKey: "itinerary.state.pending",
        label: "Pendiente",
        transitionLabelKey: "itinerary.state.pending",
        transitionLabel: "Pendiente",
        badgeClass: "bg-yellow-100 text-yellow-800 border border-yellow-300",
        menuClass: "bg-yellow-50 text-yellow-800 hover:bg-yellow-100",
        borderClass: "border-l-yellow-500",
    },
    [ITINERARY_STATE.APPROVED]: {
        value: ITINERARY_STATE.APPROVED,
        labelKey: "itinerary.state.approved",
        label: "Aprobado",
        transitionLabelKey: "itinerary.state.approved",
        transitionLabel: "Aprobado",
        badgeClass: "bg-blue-100 text-blue-800 border border-blue-300",
        menuClass: "bg-blue-50 text-blue-800 hover:bg-blue-100",
        borderClass: "border-l-blue-500",
    },
    [ITINERARY_STATE.REJECTED]: {
        value: ITINERARY_STATE.REJECTED,
        labelKey: "itinerary.state.rejected",
        label: "Rechazado",
        transitionLabelKey: "itinerary.state.rejected",
        transitionLabel: "Rechazado",
        badgeClass: "bg-red-100 text-red-800 border border-red-300",
        menuClass: "bg-red-50 text-red-800 hover:bg-red-100",
        borderClass: "border-l-red-500",
    },
    [ITINERARY_STATE.PAID]: {
        value: ITINERARY_STATE.PAID,
        labelKey: "itinerary.state.paid",
        label: "Pagado",
        transitionLabelKey: "itinerary.state.paid",
        transitionLabel: "Pagado",
        badgeClass: "bg-green-100 text-green-800 border border-green-300",
        menuClass: "bg-green-50 text-green-800 hover:bg-green-100",
        borderClass: "border-l-green-500",
    },
    [ITINERARY_STATE.CANCELLED]: {
        value: ITINERARY_STATE.CANCELLED,
        labelKey: "itinerary.state.cancelled",
        label: "Cancelado",
        transitionLabelKey: "itinerary.state.cancelled",
        transitionLabel: "Cancelado",
        badgeClass: "bg-gray-100 text-gray-800 border border-gray-300",
        menuClass: "bg-gray-50 text-gray-800 hover:bg-gray-100",
        borderClass: "border-l-gray-500",
    },
    [ITINERARY_STATE.EXPIRED]: {
        value: ITINERARY_STATE.EXPIRED,
        labelKey: "itinerary.state.expired",
        label: "Expirado",
        transitionLabelKey: "itinerary.state.expired",
        transitionLabel: "Expirado",
        badgeClass: "bg-red-100 text-red-800 border border-red-300",
        menuClass: "bg-red-50 text-red-800 hover:bg-red-100",
        borderClass: "border-l-red-500",
    },
};
export const ITINERARY_ALLOWED_TRANSITIONS = {
    [ITINERARY_STATE.PENDING]: [
        ITINERARY_STATE.APPROVED,
        ITINERARY_STATE.REJECTED,
        ITINERARY_STATE.CANCELLED,
    ],
    [ITINERARY_STATE.APPROVED]: [
        ITINERARY_STATE.PENDING,
        ITINERARY_STATE.PAID,
        ITINERARY_STATE.CANCELLED,
    ],
    [ITINERARY_STATE.REJECTED]: [
        ITINERARY_STATE.PENDING,
        ITINERARY_STATE.CANCELLED,
    ],
    [ITINERARY_STATE.PAID]: [ITINERARY_STATE.CANCELLED],
    [ITINERARY_STATE.CANCELLED]: [
        ITINERARY_STATE.PENDING,
        ITINERARY_STATE.APPROVED,
    ],
    [ITINERARY_STATE.EXPIRED]: [],
};
export const ITINERARY_FILTER_OPTIONS = ITINERARY_STATE_VALUES.map((state) => ITINERARY_STATE_CONFIG[state]);
export function isItineraryState(value) {
    return ITINERARY_STATE_VALUES.includes(value);
}
export function normalizeItineraryState(value) {
    if (isItineraryState(value))
        return value;
    return ITINERARY_STATE.PENDING;
}
export function getItineraryStateConfig(state) {
    return ITINERARY_STATE_CONFIG[normalizeItineraryState(state)];
}
export function getAllowedItineraryTransitions(state) {
    const normalizedState = normalizeItineraryState(state);
    return ITINERARY_ALLOWED_TRANSITIONS[normalizedState].map((nextState) => ITINERARY_STATE_CONFIG[nextState]);
}
export function isAllowedItineraryStateTransition(fromState, toState) {
    if (!isItineraryState(toState))
        return false;
    const transitions = ITINERARY_ALLOWED_TRANSITIONS[normalizeItineraryState(fromState)];
    return transitions.includes(toState);
}
